import { PropsWithChildren, useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { Icons } from 'app/constants/icons';
import { useModal } from 'app/components/core/Modal/Modal';
import { Button } from 'app/shared/buttons/Button';

type ModalHeaderProps = PropsWithChildren<{
  hideCloseButton?: boolean;
  boldGrayX?: boolean;
  closeXColor?: string;
}>;

export const ModalHeader = ({
  children,
  boldGrayX,
  hideCloseButton,
}: ModalHeaderProps) => {
  const {t} = useTranslation();
  const {setOpen} = useModal();

  const handleClose = useCallback(() => setOpen(false), [setOpen]);

  return (
    <div className="flex items-center justify-between">
      {children ? (
        <h2 className="flex items-center gap-0.5 text-xl font-bold leading-normal text-white">
          {children}
        </h2>
      ) : (
        <div />
      )}

      {!hideCloseButton && (
        <Button
          aria-label={t('misc.close')}
          className="text-white"
          onClick={handleClose}>
          {boldGrayX ? (
            <Icons.close
              className="text-neutral-400"
              size="25"
              strokeWidth={2}
            />
          ) : (
            <Icons.close size="25" strokeWidth={1.6} />
          )}
        </Button>
      )}
    </div>
  );
};
